import { QueryFunctionContext } from "@tanstack/react-query";

import { logger } from "c7-logger";

export const DUMMY_TOKEN = "foo";

export const queryKeys = {
  jwtPayload: (payload: string) => [{ scope: "jwt-payload", payload }] as const,
};

export const fetchJWTPayload = ({
  queryKey: [{ payload }],
}: QueryFunctionContext<ReturnType<(typeof queryKeys)["jwtPayload"]>>) => {
  if (!payload || payload === DUMMY_TOKEN) {
    return "";
  }
  const parts = payload.split(".");
  if (parts?.length !== 3) {
    logger.error("String does not follow JWT structure");
    return "";
  }
  // payload
  return atob(parts[1]);
};
